import { parseNTriple, RDF_TYPE, type RdfTerm } from "../rdf/nTriples";
import { iriLocalName } from "../references/shortReferences";

/** One N-Triples line as `subject predicate object`, each term shortened; `rdf:type` by its IRI as `a`. */
export function readableTriple(line: string): string {
  const triple = parseNTriple(line);
  if (triple === null) return line;
  const predicate = triple.predicate === RDF_TYPE ? "a" : iriLocalName(triple.predicate);
  return `${shortened(triple.subject)} ${predicate} ${shortened(triple.object)}`;
}

function shortened(term: RdfTerm): string {
  switch (term.kind) {
    case "iri":
      return iriLocalName(term.iri);
    case "blank":
      return term.label;
    case "literal":
      return JSON.stringify(term.text) + (term.language === null ? "" : `@${term.language}`);
  }
}
